"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .factory("AttachmentType", [
    "$resource",
    "$stateParams",
    "apiSettings",
    function ($resource, $stateParams, apiSettings) {
      return $resource(
        apiSettings.baseUri + "v1/attachmenttypes/:id",
        { id: "@id" },
        {
          list: {
            method: "GET",
            isArray: false,
            params: {
              page: 1,
              pageSize: apiSettings.defaultPageSize,
              keyword: "",
              moduleId: 1,
            },
          },
          listIds: {
            url: apiSettings.baseUri + "v1/attachmenttypes/list/ids",
            method: "GET",
            isArray: true,
          },
        }
      );
    },
  ]);
